<script setup>
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';

const props = defineProps({
    open: {
        type: Boolean,
        default: false
    },
    title: {
        type: String,
        default: '確認刪除'
    },
    content: {
        type: String,
        default: '確定要刪除嗎？'
    },
    okText: {
        type: String,
        default: '確認'
    },
    cancelText: {
        type: String,
        default: '取消'
    },
    iconColor: {
        type: String,
        default: '#ff4d4f'
    },
    width: {
        type: [Number, String],
        default: 440
    },
    mask: {
        type: Boolean,
        default: true
    },
    disableAnimation: {
        type: Boolean,
        default: false
    },
    bodyHeight: {
        type: String,
        default: 'auto'
    },
    maxBodyHeight: {
        type: String,
        default: '70vh'
    }
});

const emit = defineEmits(['update:open', 'confirm']);

const handleOk = () => {
    emit('confirm', true);
};

const handleCancel = () => {
    emit('confirm', false);
};
</script>

<template>
    <a-modal
        :open="open"
        :maskClosable="false"
        :mask="mask"
        :width="width"
        :centered="true"
        :closable="true"
        :transition-name="disableAnimation ? '' : undefined"
        :mask-transition-name="disableAnimation ? '' : undefined"
        :wrap-class-name="
            [disableAnimation && 'no-anim-modal', 'edit-modal', 'delete-modal']
                .filter(Boolean)
                .join(' ')
        "
        :bodyStyle="{
            height: bodyHeight,
            maxHeight: maxBodyHeight,
            overflowY: 'auto',
            paddingTop: '12px',
            paddingBottom: '4px'
        }"
        @cancel="handleCancel"
    >
        <template #title>
            <div class="delete-modal__title">
                <ExclamationCircleOutlined
                    class="delete-modal__icon"
                    :style="{ color: iconColor }"
                />
                <span>{{ title }}</span>
            </div>
        </template>

        <div class="delete-modal__body" v-html="content"></div>

        <template #footer>
            <div class="delete-modal__footer">
                <a-button @click="handleCancel">
                    {{ cancelText }}
                </a-button>
                <a-button type="primary" danger @click="handleOk">
                    {{ okText }}
                </a-button>
            </div>
        </template>
    </a-modal>
</template>

<style scoped>
.delete-modal__title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    font-weight: 600;
    color: #0f172a;
}

.delete-modal__icon {
    font-size: 20px;
    flex-shrink: 0;
}

.delete-modal__body {
    color: #475569;
    font-size: 14px;
    line-height: 1.6;
}

.delete-modal__footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}
</style>
